export enum TestGroup {
  CONTROL = 'control',
  TEST = 'test',
}
